export default "__VITE_ASSET__cEnJsPI9__"